//const { start } = require('repl');
// import { readFileSync } from 'fs'; // Import fs.promises
import * as fs from 'fs';
// idk what the abofe is honestly
// making a pseudo enum for the land types. this is ugly but so so convenient 
export const OPEN_WATER = 0;
export const CULTURE = 1; // wtf is culture???
export const MEADOW = 2; // AKA "wet meadow"
export const MEADOW_SHRUBS = 3;
export const MEADOW_REED = 4;
export const REEDBED = 5;
export const REED_SHRUBS = 6;
export const REED_WATER = 7;
export const FOREST = 8;



export const defaultFileName = "./default-initial-wetland.twm";


// because the bird data structure is too damn complex
export const LAND_TYPE_STRINGS: string[]= [...Array(10).keys()].map((num) => num.toString());
LAND_TYPE_STRINGS[OPEN_WATER]    = "OPEN_WATER";
LAND_TYPE_STRINGS[CULTURE]       = "CULTURE";
LAND_TYPE_STRINGS[MEADOW]        = "MEADOW";
LAND_TYPE_STRINGS[MEADOW_SHRUBS] = "MEADOW_SHRUBS";
LAND_TYPE_STRINGS[MEADOW_REED]   = "MEADOW_REED";
LAND_TYPE_STRINGS[REEDBED]       = "REEDBED";
LAND_TYPE_STRINGS[REED_SHRUBS]   = "REED_SHRUBS";
LAND_TYPE_STRINGS[REED_WATER]    = "REED_WATER";
LAND_TYPE_STRINGS[FOREST]        = "FOREST";


// javascript makes me do this. i hate javascript
export const CLEARINGCOSTS = [...Array(10).keys()];
CLEARINGCOSTS[OPEN_WATER]    = -9999;
CLEARINGCOSTS[CULTURE]       = -9999;
CLEARINGCOSTS[MEADOW]        = -9999;
CLEARINGCOSTS[MEADOW_SHRUBS] = 200;
CLEARINGCOSTS[MEADOW_REED]   = -9999;
CLEARINGCOSTS[REEDBED]       = 100;
CLEARINGCOSTS[REED_SHRUBS]   = 200;
CLEARINGCOSTS[REED_WATER]    = 200;
CLEARINGCOSTS[FOREST]        = 400;



// reed harvesting constants
// TODO: THIS NEED A REBALANCE. in the original game this is way to harsh to the RHs and theyre always in debt. rebalance this.
const REED_HARVESTER_MACHINE_COST = 8000; // fixed yearly cost
const REED_HARVESTER_OPERATOR_COST = 20000; // fixed yearly cost
const REED_HARVESTER_CAPACITY = 30; // harvester capacity per machine
const REED_HARVEST_NORMAL_YIELD = 1350; // 75% of high yield
const REED_HARVEST_HIGH_YIELD_MOD = 4/3;

// grazing mod, reed mod
export const FLORA_CLIMATE_VARIABILITY = [
  [2/3,2/3],   // very bad harvest
  [8/9,8/9],   // bad harvest
  [1,1],       // normal harvest
  [10/9,10/9], // good harvest
  [4/3, 4/3]   // very good harvest
];
// original game pattern was good, bad, bad, very good, bad, good, then good repeating forever
export const FLORA_CLIMATE_ORDER = [3,1,1,4,1,3]

// holds values for the accesssability / trapping rate for ducks
// first value is public, second value is private (private and public hunting is basically completely different)
export const FAUNA_CLIMATE_VARIABILITY = [
  [0.2, 0.3],   // very bad hunting conditions
  [0.4, 0.5],  // bad hunting conditions
  [0.5, 0.6],     // normal hunting conditions
  [0.6, 0.6],  // good hunting conditions
  [0.6, 0.7]    // very good hunting conditions
];
export const FAUNA_CLIMATE_ORDER = [4,2,0,4,1,3];
// original game pattern was very good, normal, very bad, very good, bad, good for the rest

// grazing constants
const GRAZE_FARM_COST = 4000; // fixed cost
const GRAZE_SALARY_COST = 15000; // fixed cost
const GRAZE_INCOME_PER_ANIMAL = 400; // idk how cows produce passive income but there you go. milk maybe
const GRAZE_FODDER_COST = 10; // if the graze value is less than what is required for the animals, then they require fodder.
const GRAZE_ANIMAL_COST = 600; // the cost to buy/sell an animal

// for grazing, these are the pastoral values for each cell type.
// i hate how i have to do it like this. javascript is terrible.
export const PASTORAL_VALUES: number[][]= [...Array(10)]
PASTORAL_VALUES[OPEN_WATER]    = [0,0,0,0];
PASTORAL_VALUES[CULTURE]       = [0,0,0,0];
PASTORAL_VALUES[MEADOW]        = [5,5,5,3];
PASTORAL_VALUES[MEADOW_SHRUBS] = [3,3,2,1];
PASTORAL_VALUES[MEADOW_REED]   = [4,4,4,3];
PASTORAL_VALUES[REEDBED]       = [3,3,2,2];
PASTORAL_VALUES[REED_SHRUBS]   = [2,1,0,0];
PASTORAL_VALUES[REED_WATER]    = [2,1,1,0];
PASTORAL_VALUES[FOREST]        = [0,0,0,0];

// same for the actions
export const NO_ACTION = 0;
export const GRAZING = 1;
export const CLEARING = 2;
export const CUT = 3;
export const ACTIONSTRINGS:{[key:string]: number} = {
  "NO_ACTION": NO_ACTION,
  "GRAZING": GRAZING,
  "CLEARING": CLEARING,
  "CUT": CUT,
}

// seasons
const SPRING = 0;
const SUMMER = 1;
const AUTUMN = 2;
const WINTER = 3;

// These are the possible plans for water level management. 0,1,2,3 is spring, summer, atumn, and winter
export const WATER_LEVEL_MANAGEMENT_SCHEMES = [
  [30, 30,30,30], // constant
  [ 0, 10,30,30], // rising
  [10,-20,10,20], // negative dip
  [20,  0, 0,10], // neutral dip
  [30,-20,10, 0]  // roller coaster
];

export function getWMRIndexFromArray(wm : number[], oneIndexed = false){
  if(!wm){
    return null;
  }
  var wmIndex = WATER_LEVEL_MANAGEMENT_SCHEMES.findIndex(
    (scheme) => scheme.length === wm.length && scheme.every((val, i) => val === wm[i])
  );
  if (oneIndexed){
    wmIndex += 1;
  }
  return wmIndex;
}

// [[no water public, low water public, medium water public, high water public],[no water private, low water private, medium water private, high water private]]
// this is insane but it means that we can differentiate between any number of birds for public and private, and we could introduce additional animals easily.
export const FAUNA_CAPACITY:{[key:string]: {[key:string]:number[][]}} = {
  "DUCK":{
    "OPEN_WATER":   [[0,16,8,4],[0,32,16,8]],
    "MEADOW":       [[0,16,4,0],[0,32,8,0]],
    "MEADOW_SHRUBS":[[0,0,0,0],[0,0,0,0]],
    "MEADOW_REED":  [[0,16,4,0],[0,32,8,0]],
    "REEDBED":      [[0,0,0,0],[0,0,0,0]],
    "REED_SHRUBS":  [[0,0,0,0],[0,0,0,0]],
    "REED_WATER":   [[0,8,4,2],[0,16,8,4]],
    "FOREST":       [[0,0,0,0],[0,0,0,0]],
  },
  "BOOMING_BITTERN":{
    "OPEN_WATER":   [[0,0,0,0],[0,0,0,0]],
    "MEADOW":       [[0,0,0,0],[0,0,0,0]],
    "MEADOW_SHRUBS":[[0,0,0,0],[0,0,0,0]],
    "MEADOW_REED":  [[0,0,0,0],[0,0,0,0]],
    "REEDBED":      [[0,0.3,0.1,0],[0,0.35,0.13,0]],
    "REED_SHRUBS":  [[0,0.3,0.1,0],[0,0.35,0.13,0]],
    "REED_WATER":   [[0,0.15,0,0],[0,0.17,0,0]],
    "FOREST":       [[0,0,0,0],[0,0,0,0]],
  },
  "PURPLE_HERON_COLONY":{
    "OPEN_WATER":   [[0,0,0,0],[0,0,0,0]],
    "MEADOW":       [[0,0,0,0],[0,0,0,0]],
    "MEADOW_SHRUBS":[[0,0,0,0],[0,0,0,0]],
    "MEADOW_REED":  [[0,0,0,0],[0,0,0,0]],
    "REEDBED":      [[0,1.5,3,0],[0,1.6,3.2,0]],
    "REED_SHRUBS":  [[0,1.5,3,0],[0,1.5,3.2,0]],
    "REED_WATER":   [[0,2.5,4.5,0],[0,2.7, 4.7,0]],
    "FOREST":       [[0,0,0,0],[0,0,0,0]],
  },
}
// some birds cannot live where reeds are being harvested
export const FAUNA_REEDHARVEST_SENSITIVITY : {[key:string]:boolean} = {
  "DUCK":false,
  "BOOMING_BITTERN":false,
  "PURPLE_HERON_COLONY":true,
};

export const DEFAULT_FAUNA = ["DUCK", "BOOMING_BITTERN", "PURPLE_HERON_COLONY"];




// TODO: Function that returns the proejcted profits and costs of an action given a wm regime
export class Cell {
  x:number;
  y:number;
  grid: WetlandGrid;
  elevation: number; // this is the base water level. AFAIK doesn't change.
  landType: number;
  landLog: number[];
  managementUnit: number;
  actionLog: number[]; // actions are per year
  actionLogIndex: number;
  wlLog:[number, number][]; // log has an array of seasons for each year
  wlLogIndex:number;
  faunaPopulation: { [key: string]: number};
  faunaLog: {[key:string]: number}[];
  faunaUpdated: boolean;
  currentYear: number;
  huntingActions: string[][];
  actionPlayerID: string;
  
  constructor(x: number, y: number, initialWaterLevel: number, initialState: number, managementUnit: number, grid: WetlandGrid) {
    this.x = x;
    this.y = y;
    this.grid = grid;
    this.elevation = initialWaterLevel; // this is the base water level. AFAIK doesn't change.
    this.landType = initialState;
    this.landLog = [initialState];
    this.managementUnit = managementUnit;
    this.actionLog = []; // actions are per year
    this.actionLogIndex = 0;
    this.wlLog = []; // log has an array of seasons for each year
    this.wlLogIndex = 0;
    this.faunaPopulation = {};
    this.faunaLog = [];
    this.faunaUpdated = false;
    this.currentYear = 0;
    this.huntingActions = [];
    this.actionPlayerID = "";
  }
  initWithInterface(cint: CellData){
    this.landLog = cint.landLog;
    this.actionLog = cint.actionLog;
    this.wlLog = cint.wlLog;
    this.faunaLog = cint.faunaLog;
  }
  getXY(){
    return [this.x, this.y];
  }
  getManagementUnit(){
    return this.managementUnit;
  }
  getCurrentWL(){
    return this.wlLog[this.wlLog.length - 1][0];
  }
  setCurrentWL(wl:number, season:number){
    this.wlLog.push([wl, season]);
  }
  getCurrentAction(){
    return this.actionLog[this.actionLog.length -1]
  }
  hasCurrentAction(year:number){
    //console.log("HAS CURRENT ACTION? ", this.actionLog.length, year);
    if(this.actionLog.length <= year){
      
      return false;
    }
    else{
      return true;
    }
  }
  setCurrentAction(action:number, playerID:string){
    
    this.actionLog.push(action);
    //console.log("SETTING ACTION ", this.x, this.y, action, this.actionLog);
    this.actionPlayerID = playerID;
  }
  changeLandType(landType:number){
    this.landType = landType;
    this.actionLogIndex = this.actionLog.length;
    this.wlLogIndex = this.wlLog.length;
  }
  // checks to see if the same action has been taken every year for x years
  actionForXYears(action:number, years:number){
    if(this.x===5){
      //console.log("ACTON FOR X YEARS : ", action, this.actionLog.length, this.actionLogIndex, years);
      //console.log("ACTION FOR X YEARS : ", this.x, this.y, action, years, this.actionLog, this.actionLogIndex);
    }
    
    if(this.actionLog.length - this.actionLogIndex < years){ // check the off by one on this maybe
      return false; // false if not enough years have passed
    }
    else {
      // return false if any other action has been taken.
      for(let i = this.actionLog.length -1; i >= this.actionLog.length - years; i--){
        //console.log("ACTION FOR X YEARS MORE : ", this.actionLog[i], action);
        if(this.actionLog[i] !== action){
          return false;
        }
      }
    }
    return true;
  }
  // seasons specifies the seasons we are including in the search
  wlForXYears(wl:number, lessThan:boolean, years:number, seasons:number[] = []){
    if(this.wlLog.length - this.wlLogIndex < (years*4)-1){
      return false; // false if not enough years have passed
    }
    else{
      let sum = 0;
      let divisor = 0;
      for(let i = this.wlLog.length -1; i > this.wlLog.length - (years*4); i--){
        if(!seasons.includes(this.wlLog[i][1]) && seasons.length != 0){ // skip this check if it is not the relevant seasons, if seasons have been specified
          continue;
        }
        sum += this.wlLog[i][0]; // sum all relevant water logs
        divisor++;
      }
      let averageWaterLevel = sum / divisor;
      if(averageWaterLevel >= wl && lessThan){ // return false if a wl is found above the threshold
        return false;
      }
      else if(averageWaterLevel <= wl && !lessThan){ // return false if a wl is found below the threshold
        return false;
      }
    }
    return true;
  }

  // returns the cost of a given action for the cell. negative means impossible
  getClearingCost(){
    return CLEARINGCOSTS[this.landType];

  }
  // gets the profit from cutting a cell. negative means impossible. can only be done on reedbed or reedbed water.
  // wlRegime is the regime for the water level, events is an array of all the random events for the year
  getCuttingRevenue(wlRegime: number[], climateVariability = FLORA_CLIMATE_VARIABILITY[2]){
    if(this.landType != REEDBED && this.landType != REED_WATER){
      return -9999;
    };
    let winterWaterLevel = wlRegime[WINTER] - this.elevation; // calculate the water level for the given regime
    if(winterWaterLevel > 20){ // cannot cut if the water level is above 20 in the winter
      return -9999;
    }
    let springWaterLevel = wlRegime[SPRING] - this.elevation;
    let highYield = false;
    let income = REED_HARVEST_NORMAL_YIELD;
    if (winterWaterLevel <= 20 && springWaterLevel > 0){ // high yield conditions
      highYield = true;
      income *= REED_HARVEST_HIGH_YIELD_MOD; // might need to round
    }
    if(this.landType == REED_WATER){ // reedbed water is half as productive as a regular reedbed.
      income *= 0.5;
    }
    income *= climateVariability[1]; // modify by the year's climate modifier
    return income;
  }
  calculateWL(season:number, wlRegime:number[]){
    return wlRegime[season] - this.elevation
  }
  advanceYear(){
    this.faunaLog.push(this.faunaPopulation);
    this.faunaPopulation = {};
    this.faunaUpdated = false;
    this.huntingActions = [];
    this.landLog.push(this.landType);
    this.currentYear++;
  }
  getPastoralValue(climateVariability = FLORA_CLIMATE_VARIABILITY[2]){
    let pastoralValue = [];
    // this needs to go into a loop so that we can multiply all elements by the climate modifier
    for (let pv of PASTORAL_VALUES[this.landType]){
      pastoralValue.push(pv * climateVariability[0]);
    }
    return pastoralValue;
  }
  // returns true if it is grazable given the WL regime
  isGrazable(wlRegime: number[]){
    for(let i = 0; i < WINTER + 1; i++){
      if(this.calculateWL(i, wlRegime) > 20){
        return false;
      }
    }
    return true;
  }
  getGrazingValue(wlRegime:number[], climateVariability = FLORA_CLIMATE_VARIABILITY[2]){
    let pvals = structuredClone(this.getPastoralValue(climateVariability));
    for(let i = 0; i < WINTER + 1; i++){
      if(this.calculateWL(i, wlRegime) > 20){
        pvals[i] = 0; // grazing value is 0 for this season if its too deep underwater. this is opposed to the og rules which make it 0 if it is >20 cm for ANY season, which is stupid.
      }
    }
    return pvals;

  }
  // use this to get the number of expected fauna in the cell, before hunting
  getFaunaCapacity(wlRegime:number[], faunaName:string): number{
    //console.log("Get fauna capacity ", this.getManagementUnit(), this.grid);
    /*
    let wlRegime :number[] = [];
    let mu = this.grid.getMU(this.managementUnit)
    if(mu.embanked && mu.waterLevelScheme != null){
      wlRegime = mu.waterLevelScheme;
    }
    else{
      wlRegime = inputWlRegime;
    }
    */

    if(!FAUNA_CAPACITY.hasOwnProperty(faunaName)){
      //console.log("TRYING TO ACCESS FAUNA THAT DOES NOT EXIST : " + faunaName);
      return -99999;
    }
    let fcc = FAUNA_CAPACITY[faunaName][LAND_TYPE_STRINGS[this.landType]];
    if(!this.grid.isPrivate(this.x,this.y)){ // if public
      var ci = 0;
    }
    else{
      var ci = 1;
    }

    // if the cell is being cut, cut sensative creatures cannot live there.
    if(FAUNA_REEDHARVEST_SENSITIVITY[faunaName] == true){
      if(this.hasCurrentAction(this.currentYear) == true){
        if(this.getCurrentAction() == CUT){
          return 0;
        }
      }
    }

    // i hate type script >:(
    let fc = fcc[ci]; // get the capacity of the current estate
    let wl = this.calculateWL(WINTER, wlRegime);
    if(wl <= 0){
      var capacity = fc[0];
    }
    else if(wl > 0 && wl <=30){
      var capacity = fc[1];
    }
    else if(wl > 30 && wl < 70){
      var capacity = fc[2];
    }
    else{ // wl >= 70
      var capacity = fc[3];
    }
    return capacity;
  }
  setFaunaCapacity(wlRegime:number[], faunaName:string){
    this.faunaPopulation[faunaName]=  this.getFaunaCapacity(wlRegime, faunaName);
  }
  // fauna is a list of fauna present in the region
  setAllFauna(wlRegime:number[], fauna:string[]){
    for(let f of fauna){
      this.setFaunaCapacity(wlRegime, f);
    }
    this.faunaUpdated = true;
  }
  // estimateCapacity estimates the population, otherwise it uses the calculated population. for ui keep this to true.
  getPotentialHuntingBag(wlRegime:number[], climateVariability = FAUNA_CLIMATE_VARIABILITY[2], faunaName = "DUCK", estimateCapacity = true){
    if (estimateCapacity){
      var capacity :any= this.getFaunaCapacity(wlRegime, faunaName);
    }
    else{
      capacity = this.faunaPopulation[faunaName];
    }
    if(!this.grid.isPrivate(this.x,this.y)){ // if public
      var ci = 0;
    }
    else{
      var ci = 1;
    }

    let huntingBag = capacity * climateVariability[ci]; // ducks * catch rate = ducks caught
    return Math.floor(huntingBag); // round down because you can't get a half duck
  }
  // execute all hunting actions
  huntFauna(wlRegime:number[], climateVariability:any){
    for(let hunt of this.huntingActions){
      let bag = this.getPotentialHuntingBag(wlRegime, climateVariability, hunt[0], false);
      let newpop: any = this.faunaPopulation[hunt[0]];
      if(newpop == undefined){
        newpop = 0;
      }
      newpop = Math.max(newpop - bag, 0)
      this.faunaPopulation[hunt[0]] = newpop;
      //TODO: AWARD MONEY HERE USING THE PLAYER ID ON hunt[1]
    }
  }
  // mark a cell as target for a hunt
  markForHunting(faunaName:string, playerID:string){
    this.huntingActions.push([faunaName, playerID]);
  }
  // returns the cell's data as a map
  intifyCell(){
    let intCell : CellData = {
      landType: this.landType,
      elevation: this.elevation,
      managementUnit: this.managementUnit,
      x: this.x,
      y: this.y,
      landLog: this.landLog,
      actionLog: this.actionLog,
      wlLog: this.wlLog,
      faunaLog: this.faunaLog,
    }
    return intCell;
  }

}

export class ManagementUnit { 
  grid: WetlandGrid;
  adjacentMUs:number[];
  unitNumber:number;
  currentYear:number;
  cells:Cell[];
  waterLevelScheme:(number[]|null);
  embanked:boolean;
  floodSource:boolean;
  natureReserve:boolean;
  hasPathToFloodSource:boolean;


  constructor(number:number, grid:WetlandGrid){
    this.grid = grid; // give access to the grid and its data
    this.adjacentMUs = [];
    this.unitNumber = number;
    this.currentYear = 0;
    this.cells = []; // each MU contains its own cells in a list
    this.waterLevelScheme = null;
    this.embanked = false; // MUs can be embanked, making them an independent hydrofunctiona unit
    this.floodSource = false; // this is true if the MU is on the bottom of the map
    this.natureReserve = false;
    // MUs on the bottom cannot be embanked and they are the source of WM flooding.
                       
    // we keep track if it has a path to the flood source. This is reset every year in case of embanking
    this.hasPathToFloodSource = false; // keeping track of this reduces the number of searches we have to do.
  }                    
  registerCell(cell:Cell){  
    this.cells.push(cell);
    if(cell.y == 0){ // if a cell is on the bottom, set bottomMU to true
      this.floodSource = true;
    }
  }
  
  // do not call embankMU or disEmbankMU from the MU, call the function in the grid instead, because this affects pathing
  embankMU(wmRegime:number[]){
    this.embanked = true;
    this.waterLevelScheme = wmRegime;
  }
  disEmbankMU(){
    this.embanked = false;
    this.waterLevelScheme = null;
  }

  // efficiency = 0.36 + cells*0.07
  // NOTE: if this returns a negative number, then it is impossible to embank
  calculateEmbankmentCost(){
    if(this.floodSource){ // it is impossible to embank any MU touching the bottom of the map.
        return -999999;
    }
    // after much deliberation i decided to keep embankment costs simple. I wasn't happy with my regression results & permimiter counting would be too intensive on calculations etc
    // The original data is very inconsistent in the cost, so we are going to reverse that trend and be very consistent.
    // in the future, we could modify this by the elevation if we choose. it is more expensive to build dikes at lower elevations (which is not represented in the original data)
    let totalCost = 4000 + this.cells.length * 1000 // simply the base cost of 4000 + 1000 for each cell.
    return totalCost;
  }
  calculateDisEmbankmentCost(){
    return this.calculateEmbankmentCost() / 2 // it costs half as much to disembank as to embank, straight down the board
  }
  // default climate to normal
  getPastoralValue(climateVariability = FLORA_CLIMATE_VARIABILITY[2]){
    let pastoralValues = [0,0,0,0];
    for(let cell of this.cells){
      let cellP = cell.getPastoralValue(climateVariability);
      pastoralValues[0] += cellP[0];
      pastoralValues[1] += cellP[1];
      pastoralValues[2] += cellP[2];
      pastoralValues[3] += cellP[3];
    }
    return pastoralValues;
  }
  // find adjacent MUs, in order to calculate paths to the ocean.
  findAdjacentMUs(){
    let coordinatesToTry = []
    for(let cell of this.cells){
      let x = cell.x;
      let y = cell.y;
      let testCoords = [[x-1,y], [x+1,y],[x,y+1],[x,y-1]];
      for(let c of testCoords){
        if(c[0] < 0 || c[0] >= this.grid.sizex || c[1] < 0 || c[1] >= this.grid.sizey){ // don't add coordinate if out of bounds
          continue;
        }
        else if (this.cells.includes(this.grid.getCell(c[0], c[1]))){ // if the coordinates are a cell in this mu don't add
          continue;
        }
        else{
          coordinatesToTry.push(c);
        }
      }
    }
    for(let coords of coordinatesToTry){
      let cell = this.grid.getCell(coords[0], coords[1]);
      let cellMU = cell.getManagementUnit()
      if(this.adjacentMUs.includes(cellMU)){ // skip if the MU has already been added
        continue;
      }
      this.adjacentMUs.push(cellMU);
    }
  }
  // returns true if there is a path to a flood source, allowing the overall water management regime to affect this.
  isPathToFloodSource(exclude:number[] = []){
    // this.unitNumber;
    if(this.floodSource || this.hasPathToFloodSource){ // if a flood source, or is known to have such a path
      this.hasPathToFloodSource = true;
      return true;
    }
    if(this.embanked){
      return false;
    }
    exclude.push(this.unitNumber); // hopefully this passes by reference
    for(let mu of this.adjacentMUs){
      if(exclude.includes(mu)){ // skip MUs that have already been searched
        continue;
      }
      let check = this.grid.getMU(mu).isPathToFloodSource(exclude);
      if(check){
        this.hasPathToFloodSource = true; // saving this reduces the searches needed in the future
        return true;
      }
    }
    return false;
  }
  // run this in order to reset the thing for the year
  resetFSPath(){
    this.hasPathToFloodSource = false; // this is reset
  }
  advanceYear(){
    this.currentYear++;
    for(let c of this.cells){
      c.advanceYear();
    }
  }
}

export class WetlandGrid {
  sizex:number;
  sizey:number;
  GridArray:(Cell)[][]
  managementUnits:ManagementUnit[]
  currentWMScheme:(number[]|null);
  constructor(sizex:number, sizey:number){
    this.sizex = sizex;
    this.sizey = sizey;
    this.GridArray = new Array(sizex).fill(null).map(() => new Array(sizey).fill(null)); // i hate javascript. this just fills a sizex x sizey array with null
    this.managementUnits = []; // initially empty. needs to be initialized after the cells are populated.
    this.currentWMScheme = null;
  }
  getCell(x:number, y:number){
    return this.GridArray[x][y];
  }
  // accepts the MU number
  getMU(mu:number){
    return this.managementUnits[mu];
  }
  // returns true if the coordinates are on private property
  isPrivate(x:number,y:number){
    let dividingLine = Math.floor(this.sizex / 2); // half of the map rounded down. This means that the public estate will always be bigger (generally more players, it is denser so they need the space idk);
    if(x < dividingLine){
      return true;
    }
    else{
      return false;
    }
  }
  // accepts the MU number
  embankMU(mu:number, wmRegime:number[]){
    this.getMU(mu).embankMU(wmRegime)
    this.resetMUPaths();
  }
  //accepts the MU number
  disEmbankMU(mu:number){
    this.getMU(mu).disEmbankMU();
    this.resetMUPaths();
  }
  // must be run after embankments are done
  resetMUPaths(){
    for(let mu of this.managementUnits){
      mu.resetFSPath();
    }
  }
  initCell(x:number, y:number, initialWaterLevel:number, initialState:number, managementUnit:number){
    this.GridArray[x][y] = new Cell(x, y, initialWaterLevel, initialState, managementUnit, this);
  }
  initManagementUnits(){ // goes through all cells and creates & adds them to the management unit
    for(let x = 0; x < this.sizex; x++){
      for(let y = 0; y < this.sizey; y++){
        let cell = this.getCell(x,y);
        if(this.managementUnits.length < cell.managementUnit + 1){
          for(let m = this.managementUnits.length; m < cell.managementUnit + 1; m++){ // fill the array with empty managment units
            this.managementUnits.push(new ManagementUnit(m, this));
          }
        }
        this.managementUnits[cell.managementUnit].registerCell(cell);
      }
    }
    // calculates MU adjacency
    for(let mu of this.managementUnits){
      mu.findAdjacentMUs();
    }
  }


  printManagementUnits(){
    console.log();
    const foregrounds = [30, 31,32,33,34,35,36,37,90,91,92,93,94,95,96,97]; // 16
    const backgrounds = [40, 41,42,43,44,45,46,47,100,101,102,104,105,106,107]; // 15
    for(let y = this.sizey -1; y >= 0; y--){
      let row = "";
      for(let x = 0; x < this.sizex; x++){
        let mu = this.getCell(x,y).managementUnit;
        let muString = mu + "";
        let bgi = mu % 15;
        let fgi = Math.floor((mu + (mu%2)/2) / 16);
        if(fgi === bgi){
          fgi = 15;
        }
        let background = backgrounds[bgi];
        let foreground = foregrounds[fgi];
        while(muString.length < 3){ // make sure each cell has 2 characters
          muString = " " + muString;
        }
        if(this.managementUnits[mu].embanked === true){
          foreground = 93;
          
        }
        let color = foreground + ";" + background + 'm';
        row += '\x1b[' + color + " " + muString;
      }
      row += '\x1b[0m';
      console.log(row);
    }
  }
  printTopography(){
    console.log();
    for(let y = this.sizey -1; y >= 0; y--){
      let row = "";
      for(let x = 0; x < this.sizex; x++){
        let elevation = this.getCell(x,y).elevation;
        const foreground = '30';
        var background;
        if (elevation >= 20){
          background = '43'; // yellow
        }
        else if(elevation === 0){
          background = '46'; // cyan
        }
        else if(elevation < 0 && elevation > -40){
          background = '104'; // bright blue

        }
        else if(elevation <= -40){
          background = '44'; // blue

        }
        let elevationString = elevation + "";
        while(elevationString.length < 3){ // make sure each cell has 3 characters
          elevationString = " " + elevationString;
        }
        let color = foreground + ";" + background + 'm';
        row += '\x1b[' + color + " " + elevationString;
      }
      row += '\x1b[0m';
      console.log(row);
    }
  }
  printLandTypes(){
    console.log();
    for(let y = this.sizey -1; y >= 0; y--){
      let row = "";
      for(let x = 0; x < this.sizex; x++){
        let landType = this.getCell(x,y).landType;
        const foreground = '30';
        var background;
        switch (landType) {
          case OPEN_WATER:
            background = '44';
            break;
          case CULTURE:
            background = '100';
            break;
          case MEADOW:
            background = '103';
            break;
          case MEADOW_SHRUBS:
            background = '43';
            break;
          case MEADOW_REED:
            background = '102';
            break;
          case REEDBED:
            background = '42';
            break;
          case REED_SHRUBS:
            background = '41';
            break;
          case REED_WATER:
            background = '46';
            break;
          case FOREST:
            background = '101';
            break;
        }
        let landTypeString = landType + ""
        while(landTypeString.length < 3){ // make sure each cell has 3 characters
          landTypeString = " " + landTypeString;
        }
        let color = foreground + ";" + background + 'm';
        row += '\x1b[' + color + " " + landTypeString;
        }
        row += '\x1b[0m';
        console.log(row);
    }
  }
}

export interface CellData{
  x:number;
  y:number;
  elevation:number;
  landType:number;
  managementUnit:number;
  landLog:number[];
  actionLog:number[];
  wlLog: [number,number][];
  faunaLog:{[key:string]: number}[];

}
export interface MuData{
  embanked:boolean;
  natureReserve:boolean;
  pathToFloodSource:boolean;
  wmRegime:(number[] | null);
}
export interface GridData{
  sizex:number;
  sizey:number;
}
export interface SimData{
  fauna:string[];
  currentYear:number,
}
export function getFaunaVariability(year:number){
  if(year > FAUNA_CLIMATE_ORDER.length){
    return FAUNA_CLIMATE_VARIABILITY[FAUNA_CLIMATE_ORDER[FAUNA_CLIMATE_ORDER.length-1]];
  }
  else{
    return FAUNA_CLIMATE_VARIABILITY[FAUNA_CLIMATE_ORDER[year]];
  }
}
export function getFloraVariability(year:number){
  if(year > FLORA_CLIMATE_ORDER.length){
    return FLORA_CLIMATE_VARIABILITY[FLORA_CLIMATE_ORDER[FLORA_CLIMATE_ORDER.length-1]];
  }
  else{
    return FLORA_CLIMATE_VARIABILITY[FLORA_CLIMATE_ORDER[year]];
  }
}
export class WetlandSimulation {
  grid:WetlandGrid;
  currentYear:number;
  currentSeason:number;
  fauna:string[];
  balanceChanges:any;
  // Constructor method to initialize instance variables
  constructor(gridx:number=0, gridy:number=0, fauna = DEFAULT_FAUNA) {
    this.grid=new WetlandGrid(gridx, gridy);
    this.currentYear = 0;
    this.currentSeason = 0;
    this.fauna = fauna; // list of fauna we are tracking
    this.balanceChanges = [];

    // empty for now
  }
  loadFile(jsonData:any){
    this.grid = loadInitialFile(jsonData);
  }
  // cell data is all of the cell states we need to keep track of
  // mu data is all of the data for the management units\
  // grid data is basic stuff like X,Y
  // sim data is meta stuff like the fauna in play
  inputGameState(cellData:CellData[][], muData:MuData[], gridData:GridData, simData:SimData){
    let clonedCellData = structuredClone(cellData);
    let clonedMuData = structuredClone(muData);
    let clonedGridData = structuredClone(gridData);
    let clonedSimData = structuredClone(simData);
    this.grid = new WetlandGrid(clonedGridData.sizex, clonedGridData.sizey);
    this.fauna = structuredClone(clonedSimData.fauna);
    this.currentYear = clonedSimData.currentYear;
    for(let x = 0; x < this.grid.sizex; x++){
      for(let y = 0; y < this.grid.sizey; y++){
        let cellMap = structuredClone(clonedCellData[x][y]);
        this.grid.initCell(cellMap.x, cellMap.y, cellMap.elevation, cellMap.landType, cellMap.managementUnit);
        this.grid.getCell(x,y).initWithInterface(cellMap); // imports logs and such
        this.grid.getCell(x,y).currentYear = clonedSimData.currentYear;
      }
    }
    this.grid.initManagementUnits();
    for(let i = 0; i < this.grid.managementUnits.length; i++){
      this.grid.managementUnits[i].embanked = clonedMuData[i].embanked;
      this.grid.managementUnits[i].natureReserve = clonedMuData[i].natureReserve;
      this.grid.managementUnits[i].waterLevelScheme = clonedMuData[i].wmRegime;
      this.grid.managementUnits[i].currentYear = clonedSimData.currentYear;
    }

  }
  // actions are an array with [ACTION, targetx, targety, playerid]. run this before running advanceYear()
  // faunaActions are ["FAUNANAME", X, Y, playerid]
  // muActions is [ACTION, MU, WMREGIME (if applicable)] options are ("EMBANK", "DISEMBANK", "NATURE_RESERVE")
  // wl is just the overall regime
  inputActions(cellActions:any, faunaActions:any, muActions:any, wmRegime:number[]){
    // console.log("CELL ACTIONS: " , cellActions);
    for(let cellAction of cellActions){
      this.grid.getCell(cellAction[1], cellAction[2]).setCurrentAction(cellAction[0], cellAction[3]); // convert string to action code, set cell to that action
    }
    for(let faunaAction of faunaActions){
      this.grid.getCell(faunaAction[1], faunaAction[2]).markForHunting(faunaAction[0], faunaAction[3]);
    }
    for(let muAction of muActions){
      let mu = this.grid.managementUnits[muAction[1]];
      switch(muAction[0]){
        case "EMBANK":
          mu.embankMU(muAction[2]);
          console.log("MU ACTION WE SET THIS TO : " + muAction[2]);
          break;
        case "DISEMBANK":
          mu.disEmbankMU();
          break;
        case "NATURE_RESERVE":
          mu.natureReserve = true;
          break;
      }
    }
    this.grid.currentWMScheme = wmRegime;
  }
  // outputs game state in the form of [cellData, muData, gridData, simData, balanceChanges]
  outputGameState(){
    let gridData: GridData = {
      sizex:this.grid.sizex,
      sizey:this.grid.sizey,
    };
    let simData: SimData = {
      fauna:this.fauna,
      currentYear:this.currentYear,
    };
    let muData = [];
    for(let mu of this.grid.managementUnits){
      let mumap: MuData ={
        embanked:mu.embanked,
        natureReserve:mu.natureReserve,
        wmRegime:mu.waterLevelScheme,
        pathToFloodSource:mu.isPathToFloodSource(),
      };
      muData.push(mumap);
    };
    let balanceChanges = this.balanceChanges;
    let cellData = new Array(this.grid.sizex).fill(null).map(() => new Array(this.grid.sizey).fill(0)); // fills with 0
    for(let x = 0; x < this.grid.sizex; x++){
      for(let y = 0; y < this.grid.sizey; y++){
        cellData[x][y] = this.grid.getCell(x,y).intifyCell();
      }
    }
    //console.log("OUTPUT STATE : ", [cellData, muData, gridData, simData, balanceChanges]);
    return [cellData, muData, gridData, simData, balanceChanges];

  }

  getFaunaVariability(year:number){
    if(year > FAUNA_CLIMATE_ORDER.length){
      return FAUNA_CLIMATE_VARIABILITY[FAUNA_CLIMATE_ORDER[FAUNA_CLIMATE_ORDER.length-1]];
    }
    else{
      return FAUNA_CLIMATE_VARIABILITY[FAUNA_CLIMATE_ORDER[year]];
    }
  }
  advanceYear(){
    if(this.grid.currentWMScheme === null){ // ensure a WM is chosen
      this.grid.currentWMScheme = WATER_LEVEL_MANAGEMENT_SCHEMES[2];
    };
    while(this.currentSeason < WINTER + 1){
      for(let x = 0; x < this.grid.sizex; x++){
        for(let y = 0; y < this.grid.sizey; y++){
          let cell = this.grid.getCell(x,y);
          let mu = this.grid.getMU(cell.managementUnit);

          let wl = -cell.elevation; // default water level is just the negative elevation
          let wmScheme = [0,0,0,0]; // nothing
          if(mu.embanked){ // if embanked, use the scheme of the embankment
            // technically wlscheme can be null so.... thanks ts
            wl = (mu.waterLevelScheme?.[this.currentSeason] ?? 0) - cell.elevation;
            //console.log("MU WATER LEVEL SCHEME : " + mu.waterLevelScheme + "\n\t test check : " + (mu.waterLevelScheme?.[this.currentSeason] ?? 0));
            wmScheme = mu.waterLevelScheme?? [0,0,0,0];
          }
          else if(mu.isPathToFloodSource()){ // if there is a path to a flood source, use the global regime
            wl = this.grid.currentWMScheme[this.currentSeason] - cell.elevation;
            wmScheme = this.grid.currentWMScheme;
          }

          cell.setCurrentWL(wl, this.currentSeason);
          if(cell.hasCurrentAction(this.currentYear) == false){
            //console.log("DEFAULTING TO NO ACTION");
            //console.log("CURRENT YEAR : ", this.currentYear);
            cell.setCurrentAction(NO_ACTION, ""); // defaults to no action
          };
          let action = cell.getCurrentAction();
          // here is where all of the harvesting logic goes

          if(this.currentSeason == WINTER){
            cell.setAllFauna(wmScheme, this.fauna);
            cell.huntFauna(wmScheme, this.getFaunaVariability(this.currentYear)); // hunt all things
     
            // here is where all of the transition logic goes. God have mercy on my soul.
            let landType = cell.landType;
        
            switch(landType){
              case FOREST:
                if(action == CLEARING){ // if winter and clearing
                  cell.changeLandType(MEADOW);
                }
                break;
              case MEADOW_SHRUBS:
                if(action === GRAZING){
                  //TODO: grazing moneys
                }
                else if(action == CLEARING){ // chopping trees
                  cell.changeLandType(MEADOW);
                }
                else if(action == NO_ACTION){ // inactivity state change, looks at spring or summer
                  if(cell.actionForXYears(NO_ACTION, 5) && cell.wlForXYears(0, true, 5, [SPRING, SUMMER])){ // if no action and wl<0 for 5 years
                    cell.changeLandType(FOREST);
                  }
                }
                break;
              case MEADOW:
                if(action == GRAZING){
                  //TODO: grazing moneys
                }
                else if(cell.actionForXYears(NO_ACTION, 5) && cell.wlForXYears(0, true, 1, [SPRING, SUMMER])){ // high water level and no action
                  cell.changeLandType(MEADOW_SHRUBS);
                }
                else if(cell.actionForXYears(NO_ACTION, 1)){
                  cell.changeLandType(MEADOW_REED);
                }
                break;
              case MEADOW_REED:
                if(action == GRAZING){ // grazing will turn it into a meadow over the course of the year, the transformation takes place in winter.
                  //TODO: grazing moneys
                  cell.changeLandType(MEADOW);
                }
                else if(cell.actionForXYears(NO_ACTION, 1)){
                  cell.changeLandType(REEDBED);
                }
                break;
              case REEDBED:
                if(action == GRAZING){
                  //TODO: grazing moneys
                  if(this.currentSeason == WINTER){
                    cell.changeLandType(MEADOW);
                  }
                }
                else if(action == CLEARING){
                  cell.changeLandType(REED_WATER);
                }
                else if(cell.actionForXYears(NO_ACTION, 1) && cell.wlForXYears(0, true, 1, [SPRING, SUMMER])){ // reedbed dries out
                  cell.changeLandType(REED_SHRUBS);
                }
                else if((cell.wlForXYears(20, false, 3, [SUMMER]) && cell.actionForXYears(CUT, 3)) || (cell.wlForXYears(20, false, 5, [SUMMER]) && cell.actionForXYears(NO_ACTION, 5))){
                  cell.changeLandType(REED_WATER);
                }
                else{
                }
                break;
              case REED_SHRUBS:
                if(action == CLEARING || action == GRAZING){
                  cell.changeLandType(REEDBED);
                }
                else if(cell.wlForXYears(0, true, 5, [SPRING, SUMMER]) && cell.actionForXYears(NO_ACTION, 5)){ //low water levels and no action during sp or s
                  cell.changeLandType(FOREST);
                }
                else if(cell.wlForXYears(30, false, 3) && cell.actionForXYears(NO_ACTION, 3)){
                  cell.changeLandType(OPEN_WATER);
                }
                break;
              case REED_WATER:
                if(action == CLEARING){
                  cell.changeLandType(OPEN_WATER);
                }
                else if((cell.wlForXYears(20, false, 3, [SUMMER]) && cell.actionForXYears(NO_ACTION, 3)) || cell.actionForXYears(CUT, 1)){
                  //console.log("WHY IS THIS TURNING OPEN WATER ", cell.intifyCell(), cell.wlForXYears(20, false, 3, [SUMMER]), cell.actionForXYears(NO_ACTION, 3), cell.actionForXYears(CUT, 1));
                  cell.changeLandType(OPEN_WATER);
                }
                else if(cell.wlForXYears(0, true, 3, [SUMMER]) && cell.actionForXYears(NO_ACTION, 3)){
                  cell.changeLandType(REEDBED);
                }
                break;
              case OPEN_WATER:
                if(cell.wlForXYears(0, true, 3, [SUMMER]) && cell.actionForXYears(NO_ACTION, 3)){
                  cell.changeLandType(REED_WATER);
                }
                break;
            }
          }
        }
      }
      this.currentSeason++;
    }
    this.currentYear++;
    this.currentSeason = SPRING;
    for(let mu of this.grid.managementUnits){
      //console.log("ADVANCING MU YEARS ", this.currentYear);
      mu.advanceYear();
    }
  }
}

function loadInitialFile(jsonData : any){

  let sizex = jsonData.grid.width;
  let sizey = jsonData.grid.height;
  var grid = new WetlandGrid(sizex, sizey); // init grid

  jsonData.cells.forEach((cell:any) => { // move the cell values over from the json
      // ionsole.log(cell);
      let topo = parseInt(cell.topography.split(" ")[0]); // gets the cm elevation "+20 cm" (amazingly javascript doesn't care about the + when parsing the int. WOW!!)
      let munit = parseInt(cell["management-units"].split(" ")[1]) -1 // gets unit number "Unit x", minus one because we are 0 indexed

      /* 
      * now we need to give the cell a land-type code corresponding to the land time name in the .twm file. 
      * We need to do this so that the original file is readable, and our code is less finnicky and we can use our pseudo enum hell yeah.
      * The below is a dictionary so that we dont have to use a switch. (i hope the js interpreter is smart enough to run the def once)
      */
      const landTypeConversion:{[key:string]: number}= {
          "Open Water": OPEN_WATER,
          "Culture": CULTURE,
          "Meadow": MEADOW,
          "Meadow+shrubs": MEADOW_SHRUBS,
          "Meadow+reed": MEADOW_REED,
          "Reedbed": REEDBED,
          "Reed+shrubs": REED_SHRUBS,
          "Reed+water": REED_WATER,
          "Forest": FOREST
      };
      let landType = landTypeConversion[cell["land-type"]];
      // TODO: add a check here to display an error if the land type is invalid.

      grid.initCell(cell.col, cell.row, topo, landType, munit);
  });
  grid.initManagementUnits();
  return grid;
};

/*
export async function startSimulation(){
  console.log("START");
  var simulation = new WetlandSimulation(0,0);
  await simulation.loadFile()
  var grid = simulation.grid;
  console.log("MANAGEMENT UNITS:");
  grid.printManagementUnits();
  console.log("TOPOGRAPHICAL MAP:");
  grid.printTopography();
  console.log("LAND TYPES:");
  grid.currentWMScheme = WATER_LEVEL_MANAGEMENT_SCHEMES[0];
  grid.printLandTypes();
  
  simulation.advanceYear();
  grid.printLandTypes();
  simulation.advanceYear();
  let olddata = simulation.outputGameState();
  grid.printLandTypes();
  simulation.advanceYear();
  simulation.inputGameState(olddata[0], olddata[1], olddata[2], olddata[3]);
  grid.printLandTypes();
  simulation.advanceYear();
  grid.printLandTypes();
//  simulation.advanceYear();
//  simulation.advanceYear();
//  simulation.advanceYear();
//  simulation.advanceYear();
//  simulation.advanceYear();
  console.log("NEW LAND TYPES:");
  grid.printLandTypes();
  grid.embankMU(6 , WATER_LEVEL_MANAGEMENT_SCHEMES[4]);
  grid.embankMU(7 , WATER_LEVEL_MANAGEMENT_SCHEMES[4]);
  grid.embankMU(15, WATER_LEVEL_MANAGEMENT_SCHEMES[4]);
  grid.embankMU(16, WATER_LEVEL_MANAGEMENT_SCHEMES[4]);
  
  console.log(simulation.outputGameState());
  /*
  for(mu of grid.managementUnits){
    console.log("MU : " + mu.unitNumber)
    console.log("\tFlood Source : " + mu.floodSource);
    console.log("\tEmbanked    : " + mu.embanked);
    console.log("\tAdjacent    : " + mu.adjacentMUs);
    console.log("\tPath to flood source : " + mu.isPathToFloodSource());
  }
  
  for(mu of grid.managementUnits){
    for(let cell of mu.cells){
      console.log("Cell " + cell.x + "," + cell.y);
      console.log("\tCell Land Use   : " + cell.landType);
      console.log("\tClearing Cost   : " + cell.getClearingCost());
      console.log("\tCutting Revenue : " + cell.getCuttingRevenue(WATER_LEVEL_MANAGEMENT_SCHEMES[4]));
      console.log("\tPastoral Value  : " + cell.getPastoralValue());
    }
  }
  /*
  for(mu of grid.managementUnits){
    console.log("MU : " + mu.unitNumber)
    console.log("\tEmbankment Cost    : " + mu.calculateEmbankmentCost())
    console.log("\tDisembankment Cost : " + mu.calculateDisEmbankmentCost())
    console.log("\tSum Pastoral Value : " + mu.getPastoralValue())
  }
 
}

// startSimulation();
*/
